import React from 'react';
import styled from 'styled-components';
import Compnay from './Company';
import Jobs from './Jobs';
import PressRelease from './PressRelease';
import Fiscal from './Fiscal';
import {StringParam, useQueryParam} from 'use-query-params';
import CompanyEdit from './CompanyEdit';
import usePreleadContext from './usePreleadContext';
import KeyPerson from './KeyPerson';

export default () => {
  const {preleadId} = usePreleadContext();

  if (!preleadId) return null;

  const [information, setInformation] = useQueryParam(
    'information',
    StringParam,
  );
  if (!information) return null;

  if (information === 'company_edit') {
    return (
      <Container>
        <CompanyEdit onClose={() => setInformation('company')} />
      </Container>
    );
  }

  return (
    <Container>
      <ContentWrapper>
        {information === 'company' && <Compnay />}
        {information === 'jobs' && <Jobs />}
        {information === 'pressrelease' && <PressRelease />}
        {information === 'fiscal' && <Fiscal />}
        {information === 'key_person' && <KeyPerson />}
      </ContentWrapper>
    </Container>
  );
};

const Container = styled.div`
  width: 400px;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border-left: 1px solid var(--border-color);
`;

const ContentWrapper = styled.div`
  overflow: scroll;
  padding: 32px 30px 0 30px;
`;
